import { render, staticRenderFns } from "./side-wrapper.vue?vue&type=template&id=0bf73f98&"
import script from "./side-wrapper.vue?vue&type=script&lang=js&"
export * from "./side-wrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports